"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineAppointment = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = __importStar(require("react"));
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const react_native_1 = require("react-native");
const organisms_1 = require("../../../organisms");
const atome_1 = require("../../../atome");
const OnlineAppointment_web_style_1 = require("./OnlineAppointment.web.style");
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
const User_service_1 = __importDefault(require("../../../../services/User.service"));
const Appointment_service_1 = __importDefault(require("../../../../services/Appointment.service"));
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const StepOneOnlineAppointment_1 = require("./OnlineAppointmentSteps/StepOneOnlineAppointment");
const StepTwoOnlineAppointment_1 = require("./OnlineAppointmentSteps/StepTwoOnlineAppointment");
const StepThreeOnlineAppointment_1 = require("./OnlineAppointmentSteps/StepThreeOnlineAppointment");
const doctorslot_enum_1 = require("../../../../enums/doctorslot.enum");
const InputLoader_1 = __importDefault(require("../../../atome/InputLoader/InputLoader"));
// @ts-ignore
function OnlineAppointment({ navigation, currentPage, setCurrentPage }) {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const userInfo = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const [slotType, setSlotType] = (0, react_1.useState)(doctorslot_enum_1.DOCTOR_SLOT.FOLLOW_UP_APPOINTMENT);
    // const [doctors, setDoctors] = useState([]);
    const [mainDoctor, setMainDoctor] = (0, react_1.useState)();
    const [doctorSlots, setDoctorSlots] = (0, react_1.useState)([]);
    const [displayDoctorSlots, setDisplayDoctorSlots] = (0, react_1.useState)([]);
    const [selectedDate, setSelectedDate] = (0, react_1.useState)(new Date(new Date().setHours(0, 0, 0, 0)));
    const [selectedSlot, setSelectedSlot] = (0, react_1.useState)();
    const [isSaving, setSaving] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(false);
    const [hasAppointment, setHasAppointment] = (0, react_1.useState)(false);
    const [assignedDoctor, setAssignedDoctor] = (0, react_1.useState)();
    const getDoctorSlots = (doctorId, slotType) => {
        User_service_1.default.getDoctorOnlineSlotsBySlotType(doctorId, slotType).then(res => {
            if (res.error) {
                if (res.message.response.status === 401) {
                    dispatch((0, reducers_1.setAuth)({ isAuthenticated: false }));
                    navigation.navigate('Login');
                }
                console.log(res.message);
            }
            setDoctorSlots(res.data);
            setLoading(false);
        });
    };
    const reloadDoctorSlots = (0, react_1.useCallback)(() => {
        setLoading(true);
        setSelectedSlot(undefined);
        getDoctorSlots(mainDoctor.doctorId, slotType);
        setError(false);
    }, [slotType]);
    const isNextDay = (date) => {
        return (new Date(date).setHours(23, 59, 59, 0) < new Date().setHours(0, 0, 0, 0));
    };
    const getAllAppointments = async () => {
        const appointmentsData = await Appointment_service_1.default.getAllAppointments();
        if (appointmentsData.error) {
            dispatch((0, reducers_1.setAuth)({ isAuthenticated: false }));
            navigation.navigate('Login');
        }
        return appointmentsData.data;
    };
    const checkHasActualAppointment = (appointmentData) => !isNextDay(appointmentData[appointmentData.length - 1].startDate);
    const getSlotTypeByCase = (isAlreadyCannabisPatient, isFirstAppointment) => {
        if (isAlreadyCannabisPatient && isFirstAppointment) {
            return doctorslot_enum_1.DOCTOR_SLOT.FIRST_APPOINTMENT;
        }
        if ((isAlreadyCannabisPatient && !isFirstAppointment) ||
            (!isAlreadyCannabisPatient && !isFirstAppointment)) {
            return doctorslot_enum_1.DOCTOR_SLOT.FOLLOW_UP_APPOINTMENT;
        }
        if (!isAlreadyCannabisPatient && isFirstAppointment) {
            return doctorslot_enum_1.DOCTOR_SLOT.FIRST_APPOINTMENT;
        }
        return doctorslot_enum_1.DOCTOR_SLOT.FOLLOW_UP_APPOINTMENT;
    };
    (0, react_1.useEffect)(() => {
        return navigation.addListener('focus', async () => {
            setLoading(true);
            const appointmentsData = await getAllAppointments();
            const isFirstAppointment = appointmentsData.length === 0;
            if (!isFirstAppointment) {
                let hasActualAppointment = checkHasActualAppointment(appointmentsData);
                if (hasActualAppointment) {
                    navigation.navigate('Dashboard');
                    return;
                }
            }
            User_service_1.default.getDoctors()
                .then(res => {
                if (res.error) {
                    if (res.message.response.status === 401) {
                        dispatch((0, reducers_1.setAuth)({ isAuthenticated: false }));
                        navigation.navigate('Login');
                    }
                    console.log(res.message);
                }
                const mainDoc = res.data.find((doctor) => doctor.doctorType === 'main' || doctor.doctorType === 1);
                const { isAlreadyCannabisPatient } = userInfo;
                const isFirstAppointment = appointmentsData.length === 0;
                const slotType = getSlotTypeByCase(isAlreadyCannabisPatient, isFirstAppointment);
                setSlotType(slotType);
                setMainDoctor(mainDoc);
                // setDoctors(res.data);
                getDoctorSlots(mainDoc.doctorId, slotType);
            })
                .catch(err => {
                console.log(err.message);
            });
        });
    }, []);
    (0, react_1.useEffect)(() => {
        const slots = doctorSlots.filter((slot) => new Date(new Date(slot.start).setHours(0, 0, 0, 0)).getTime() ===
            new Date(selectedDate).getTime());
        slots.sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
        setSelectedSlot(undefined);
        setDisplayDoctorSlots(slots);
    }, [selectedDate]);
    (0, react_1.useEffect)(() => {
        const getDoctor = async () => {
            if (selectedSlot) {
                const doctor = await User_service_1.default.getDoctor(parseInt(selectedSlot.doctorId));
                setAssignedDoctor(doctor.data);
            }
        };
        getDoctor();
    }, [selectedSlot]);
    const bookAppointment = async () => {
        setSaving(true);
        let appointments = await getAllAppointments();
        const hasAppointments = appointments.length > 0;
        if (hasAppointments) {
            const hasActualAppointment = checkHasActualAppointment(appointments);
            if (hasActualAppointment) {
                setHasAppointment(true);
                setSaving(false);
                return;
            }
        }
        if (selectedSlot) {
            let doctor;
            const appointmentData = {
                doctorName: '',
                doctorId: 0,
                startDate: selectedSlot.start,
                endDate: selectedSlot.end,
                comment: 'Von Patient erstellt',
                type: 'online',
                appointmentType: slotType === doctorslot_enum_1.DOCTOR_SLOT.FIRST_APPOINTMENT
                    ? 'firstAppointment'
                    : 'followUpAppointment',
            };
            if (parseInt(selectedSlot.doctorId) === mainDoctor?.doctorId) {
                appointmentData.doctorName = `${mainDoctor.doctor.firstname}${mainDoctor.doctor.lastname}`;
                appointmentData.doctorId = mainDoctor.doctorId;
                doctor = { doctor: { ...assignedDoctor.doctor, doctorType: 'main' } };
            }
            else {
                appointmentData.doctorName = `${assignedDoctor.doctor.firstname}${assignedDoctor.doctor.lastname}`;
                appointmentData.doctorId = parseInt(selectedSlot.doctorId);
                doctor = { doctor: { ...assignedDoctor.doctor, doctorType: 'sub' } };
                const doctorResponse = await User_service_1.default.assignDoctorWithType(parseInt(userInfo.id), parseInt(selectedSlot.doctorId), 'sub');
                if (doctorResponse.error) {
                    console.log(doctorResponse);
                    setLoading(false);
                    return;
                }
            }
            await async_storage_1.default.setItem('appointmentData', JSON.stringify(appointmentData));
            await async_storage_1.default.setItem('appointmentDoctor', JSON.stringify(doctor));
            Appointment_service_1.default.createAppointment(appointmentData).then(res => {
                if (res.error) {
                    setError(true);
                    if (res.message.response.status === 401) {
                        dispatch((0, reducers_1.setAuth)({ isAuthenticated: false }));
                        navigation.navigate('Login');
                        setError(false);
                    }
                    console.log(res.message);
                }
                setSaving(false);
                if (!res.error) {
                    navigation.navigate('AppointmentSuccess');
                }
            });
        }
    };
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    if (Breakpoints_1.isMobile || Breakpoints_1.isTablet) {
        if (currentPage === 1) {
            return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
                react_1.default.createElement(StepOneOnlineAppointment_1.StepOneOnlineAppointment, { navigation: navigation, setCurrentPage: setCurrentPage, hasAppointment: hasAppointment, setHasAppointment: setHasAppointment, doctorSlots: doctorSlots, selectedDate: selectedDate, setSelectedDate: setSelectedDate, selectedSlot: selectedSlot, mainDoctor: mainDoctor?.doctorId })));
        }
        if (currentPage === 2) {
            return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
                react_1.default.createElement(StepTwoOnlineAppointment_1.StepTwoOnlineAppointment, { setCurrentPage: setCurrentPage, error: error, setError: setError, reloadDoctorSlots: reloadDoctorSlots, displayDoctorSlots: displayDoctorSlots, selectedDate: selectedDate, selectedSlot: selectedSlot, setSelectedSlot: setSelectedSlot })));
        }
        if (currentPage === 3) {
            return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
                react_1.default.createElement(StepThreeOnlineAppointment_1.StepThreeOnlineAppointment, { selectedSlot: selectedSlot, assignedDoctor: assignedDoctor, setAssignedDoctor: setAssignedDoctor, isSaving: isSaving, bookAppointment: bookAppointment })));
        }
    }
    return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
        react_1.default.createElement(react_native_1.SafeAreaView, null,
            react_1.default.createElement(react_native_1.ScrollView, null,
                react_1.default.createElement(atome_1.Modal, { modalVisible: error, setModalVisible: setError, cb: reloadDoctorSlots, disableSecondaryButton: true },
                    react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_web_style_1.styles.textAlignCenter] }, "Der Termin ist leider schon vergeben. Bitte w\u00E4hlen Sie einen anderen Termin.")),
                react_1.default.createElement(atome_1.Modal, { modalVisible: hasAppointment, setModalVisible: setHasAppointment, cb: () => {
                        setHasAppointment(false);
                        navigation.navigate('Dashboard');
                    }, disableSecondaryButton: true },
                    react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_web_style_1.styles.textAlignCenter] }, "Sie haben bereits einen Termin. Nehmen Sie den Termin erst war, bevor Sie einen neuen buchen.")),
                react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
                react_1.default.createElement(react_native_1.View, { style: [OnlineAppointment_web_style_1.styles.container] },
                    react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.marginBottom40] },
                        react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_web_style_1.styles.heading2] }, "VIDEOSPRECHSTUNDE"),
                        react_1.default.createElement(atome_1.Label, null, "Bitte w\u00E4hlen Sie einen Tag und eine Uhrzeit f\u00FCr Ihre Videosprechstunde."),
                        react_1.default.createElement(atome_1.Label, null, " "),
                        react_1.default.createElement(atome_1.Label, null, "W\u00E4hlen Sie im Kalender einen Tag und anschlie\u00DFend eine Uhrzeit f\u00FCr Ihren Termin. Best\u00E4tigen Sie diesen dann mit \"JETZT BUCHEN\".")),
                    react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.marginTop20] },
                        react_1.default.createElement(react_native_1.View, { style: [OnlineAppointment_web_style_1.styles.calendarContainer] },
                            react_1.default.createElement(organisms_1.Calendar, { slots: doctorSlots, onChange: setSelectedDate, selectedDate: selectedDate, mainDoctor: mainDoctor?.doctorId, navigation: navigation })),
                        react_1.default.createElement(react_native_1.View, { style: [OnlineAppointment_web_style_1.styles.calendarInformationContainer] }, displayDoctorSlots.length === 0 ? (react_1.default.createElement(atome_1.Label, null, "Keine Termine f\u00FCr diesen Tag")) : (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.marginBottom20] },
                                react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.positionRelative] },
                                    react_1.default.createElement(atome_1.Icon, { icon: 'calendar', size: 90, color: '#000' }),
                                    react_1.default.createElement(atome_1.Text, { style: [
                                            OnlineAppointment_web_style_1.styles.textBold,
                                            GlobalStyles_1.globalStyles.positionAbsolute,
                                            OnlineAppointment_web_style_1.styles.heading2,
                                            OnlineAppointment_web_style_1.styles.selectedDateDay,
                                        ] }, new Date(selectedDate)
                                        .getDate()
                                        .toLocaleString('de-DE', {
                                        minimumIntegerDigits: 2,
                                    }))),
                                react_1.default.createElement(react_native_1.View, { style: [
                                        GlobalStyles_1.globalStyles.marginLeft20,
                                        OnlineAppointment_web_style_1.styles.justifyCenter,
                                    ] },
                                    react_1.default.createElement(atome_1.Text, null, "Verf\u00FCgbare Termine"),
                                    react_1.default.createElement(atome_1.Text, null,
                                        "am",
                                        ' ',
                                        new Date(selectedDate).toLocaleString('de-DE', {
                                            day: '2-digit',
                                            month: 'long',
                                            year: 'numeric',
                                        })))),
                            react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(atome_1.Text, null, "Bitte w\u00E4hlen Sie eine Uhrzeit.")),
                            react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, OnlineAppointment_web_style_1.styles.slotsContainer] }, displayDoctorSlots.map((slot) => (react_1.default.createElement(atome_1.Text, { key: slot.start, style: [
                                    OnlineAppointment_web_style_1.styles.slot,
                                    selectedSlot === slot && OnlineAppointment_web_style_1.styles.activeSlot,
                                ], onPress: () => setSelectedSlot(slot) },
                                new Date(slot.start).toLocaleTimeString([], {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                }),
                                ' ',
                                "Uhr")))))))),
                    selectedSlot && (react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            GlobalStyles_1.globalStyles.marginTop75,
                            OnlineAppointment_web_style_1.styles.selectedAppointmentContainer,
                        ] },
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.positionRelative] },
                            react_1.default.createElement(atome_1.Icon, { icon: 'calendar', size: 90 }),
                            react_1.default.createElement(atome_1.Text, { style: [
                                    OnlineAppointment_web_style_1.styles.colorWhite,
                                    OnlineAppointment_web_style_1.styles.textBold,
                                    GlobalStyles_1.globalStyles.positionAbsolute,
                                    OnlineAppointment_web_style_1.styles.heading2,
                                    OnlineAppointment_web_style_1.styles.selectedDateDay,
                                ] }, selectedSlot
                                ? new Date(selectedSlot.start)
                                    .getDate()
                                    .toLocaleString('de-DE', {
                                    minimumIntegerDigits: 2,
                                })
                                : '?')),
                        react_1.default.createElement(react_native_1.View, { style: [
                                GlobalStyles_1.globalStyles.column,
                                GlobalStyles_1.globalStyles.marginTop10,
                                GlobalStyles_1.globalStyles.marginLeft20,
                                OnlineAppointment_web_style_1.styles.selectedAppointmentWrapper,
                            ] },
                            react_1.default.createElement(atome_1.Text, { style: [
                                    OnlineAppointment_web_style_1.styles.colorWhite,
                                    OnlineAppointment_web_style_1.styles.heading2,
                                    OnlineAppointment_web_style_1.styles.selectedAppointmentHeader,
                                ] }, "IHRE VIDEOSPRECHSTUNDE"),
                            react_1.default.createElement(react_native_1.View, { style: [
                                    GlobalStyles_1.globalStyles.row,
                                    OnlineAppointment_web_style_1.styles.spaceBetween,
                                    OnlineAppointment_web_style_1.styles.selectedAppointmentText,
                                ] },
                                react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row] },
                                    react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_web_style_1.styles.colorWhite] }, "Datum / Uhrzeit:"),
                                    react_1.default.createElement(atome_1.Text, { style: [
                                            OnlineAppointment_web_style_1.styles.colorWhite,
                                            GlobalStyles_1.globalStyles.marginLeft10,
                                            OnlineAppointment_web_style_1.styles.textBold,
                                        ] }, selectedSlot
                                        ? new Date(selectedSlot.start).toLocaleString('de-DE', {
                                            day: '2-digit',
                                            month: 'long',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                        }) + ' Uhr'
                                        : '')),
                                react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row] },
                                    react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_web_style_1.styles.colorWhite] }, "Arzt / \u00C4rztin:"),
                                    react_1.default.createElement(atome_1.Text, { style: [
                                            OnlineAppointment_web_style_1.styles.colorWhite,
                                            GlobalStyles_1.globalStyles.marginLeft10,
                                            OnlineAppointment_web_style_1.styles.textBold,
                                        ] },
                                        assignedDoctor && assignedDoctor?.doctor.title
                                            ? assignedDoctor?.doctor.title === 'doctor'
                                                ? 'Dr.'
                                                : assignedDoctor?.doctor.title === 'professor'
                                                    ? 'Prof.'
                                                    : ''
                                            : '',
                                        assignedDoctor && assignedDoctor?.doctor.firstname,
                                        ' ',
                                        assignedDoctor && assignedDoctor?.doctor.lastname)))))),
                    react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, OnlineAppointment_web_style_1.styles.buttonContainer] },
                        react_1.default.createElement(react_native_1.Pressable, { pointerEvents: isSaving ? 'none' : 'auto', style: [
                                isSaving ? OnlineAppointment_web_style_1.styles.buttonLoading : OnlineAppointment_web_style_1.styles.button,
                                GlobalStyles_1.globalStyles.saveButtonContainer,
                            ], onPress: bookAppointment },
                            isSaving ? react_1.default.createElement(InputLoader_1.default, null) : null,
                            react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_web_style_1.styles.buttonText] }, "Jetzt buchen"))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            OnlineAppointment_web_style_1.styles.justifyCenter,
                            GlobalStyles_1.globalStyles.marginBottom20,
                        ] },
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => navigation.navigate('Dashboard') },
                            react_1.default.createElement(atome_1.Text, { style: [OnlineAppointment_web_style_1.styles.backButtonText] }, "\u2190 Zur\u00FCck"))))))));
}
exports.OnlineAppointment = OnlineAppointment;
